<template>
  <div class="doc-process">
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      top="8vh"
      width="880px"
    >
      <div v-loading="loading" class="content">
        <p class="d-title">{{ contentTitle }}预览</p>
        <div ref="prevEl" class="dic-view" />
        <p class="tips">请确认数据无误后进行下载</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleDown">下载</el-button>
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import JSZipUtils from 'jszip-utils'
import { renderAsync } from '@/utils/docx-preview.min.js'
import { downloadBlob } from '@/api/common'

export default {
  name: 'DocProcess',

  props: {
    title: {
      type: String,
      reuqired: true
    },
    contentTitle: {
      type: String,
      reuqired: true
    },
    templatePath: {
      type: String,
      reuqired: true
    },
    info: {
      type: Object,
      reuqired: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      blob: null
    }
  },
  methods: {
    init () {
      this.createWord()
      this.dialogVisible = true
      this.loading = true
    },
    createWord () {
      JSZipUtils.getBinaryContent(this.templatePath, (error, content) => {
        if (error) {
          console.error(error)
          this.loading = false
          return
        }
        const zip = new PizZip(content)
        const doc = new Docxtemplater()
          .loadZip(zip)
          .setOptions({ linebreaks: true })
          .compile()

        doc
          .resolveData(this.info)
          .then(() => {
            doc.render()
            const out = doc.getZip().generate({
              type: "blob",
              mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            })
            this.loading = false
            renderAsync(
              out, // Blob | ArrayBuffer | Uint8Array, 可以是 JSZip.loadAsync 支持的任何类型
              this.$refs.prevEl, // HTMLElement 渲染文档内容的元素,
              null, // HTMLElement, 用于呈现文档样式、数字、字体的元素。如果为 null，则将使用 bodyContainer。
              {
                className: "docx-preview"
              }
            )
            this.blob = out
          })
      })
    },
    // 下载
    handleDown () {
      downloadBlob(this.blob, this.contentTitle)
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.doc-process {
  ::v-deep .el-dialog__body {
    padding: 30px 30px;
  }
}
.d-title {
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #999999;
  margin-bottom: 24px;
  color: #333333;
}
.tips {
  font-size: 12px;
  margin-top: 24px;
}
::v-deep .dic-view {
  height: 60vh;
  overflow-y: auto;
  .docx-preview-wrapper {
    padding: 10px;
    background: transparent;
  }
}
</style>
